import React, { useState } from 'react';
import $ from 'jquery';
import axios from 'axios';
import './style.scss';

const ModalLike = ({ user, capacity }) => {
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  const path = window.location.pathname;
  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    $('#modal-like').removeClass('show').css('display', 'none');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    if (!form?.feedback) {
      return;
    }
    axios
      .post('/api/v1/feedback/platform', {
        ...form,
        platform: path.replace('/nen-tang-so/', ''),
      })
      .then(({ data }) => {
        window.location.reload();
      })
      .catch(() => {
        window.location.reload();
      });
  };
  return (
    <div className='modal fade modal-like' id='modal-like'>
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <div className='modal-success-content'>
            <h5 className='text-center like-title'>Phản hồi cho nền tảng</h5>
            {user ? (
              <form
                action=''
                method=''
                onSubmit={(e) => {
                  handleLogin(e);
                }}
              >
                <div className='form-group'>
                  <label>Nội dung</label>
                  <textarea
                    type='text'
                    name='feedback'
                    placeholder=''
                    required
                    onChange={(e) => {
                      handleForm(e.target.value, 'feedback');
                    }}
                  />
                </div>
                <div className='modal-like-action'>
                  <button type='submit' className='btn_submit flex-center'>
                    Like & Gửi phản hồi
                  </button>
                </div>
              </form>
            ) : (
              <div className='request-action-like'>
                {capacity == 2 ? (
                  <span
                    className='text-center'
                    style={{ marginBottom: '10px' }}
                  >
                    Bạn cần Đăng ký sử dụng nền tảng trước.
                  </span>
                ) : (
                  <>
                    <span
                      className='text-center'
                      style={{ marginBottom: '10px' }}
                    >
                      Bạn cần đăng nhập để sử dụng tính năng này.
                    </span>
                    <button
                      type='button'
                      className='btn_login flex-center'
                      data-dismiss='modal'
                      data-toggle='modal'
                      data-target='#modal-login'
                    >
                      Đăng nhập
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLike;
